import React from 'react';
import tw from 'twin.macro';

import { containerInfo2 } from '@/app/utils/containerInfo';
import MobileAppImage from '@/assets/images/MobileAppImage.png';
import { BigTitle } from '@/components';

import RevealingContainer from '../revealing-container';
function LandingDepositWithdaw() {
  return (
    <div>
      <BigTitle
        text={'Удобно выводить деньги'}
        twStyle={tw`sm:text-[34px] text-[24px] text-[#70FF6E] sm:mb-20 mb-10`}
      />
      <div tw='flex sm:flex-row flex-col-reverse items-center  w-full gap-10 sm:items-start'>
        <div tw='flex flex-col gap-3 w-full'>
          {containerInfo2.map(item => (
            <RevealingContainer cardInfo={item} key={item.title} withSticker={item?.withSticker} />
          ))}
        </div>
        <img src={MobileAppImage} alt='' tw='sm:max-w-[400px]  max-w-[250px]' />
      </div>
    </div>
  );
}

export default LandingDepositWithdaw;
